/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreateCardAccountRequestAccountType = typeof CreateCardAccountRequestAccountType[keyof typeof CreateCardAccountRequestAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountRequestAccountType = {
  'asset-link': 'asset-link',
  prepaid: 'prepaid',
  'fixed-limit': 'fixed-limit',
  'asset-link-dynamic-limit': 'asset-link-dynamic-limit',
} as const;
